import React, { useContext, useState, useEffect } from "react";
import { motion } from "framer-motion";
import Footer from "../components/Footer/Footer";
import AboutMe from "../components/About/AboutMe";
import OfficeTitle from "../components/Three/OfficeTitle";
import LoadingHome from "../components/Loading/LoadingHome";
import { Context } from "../context";

const AboutMePage = () => {
  const { debug, lang } = useContext(Context);
  const [text, setText] = useState("");
  const [text2, setText2] = useState("");

  useEffect(() => {
    if (lang === "en") {
      setText("About me");
      setText2("Some information about me");
    } else if (lang === "it") {
      setText("Chi sono");
      setText2("Alcune info su di me");
    }
  }, [lang]);

  return (
    <>
      <title>Davide Balice - About me</title>
      <LoadingHome />
      <motion.main
        initial={{ opacity: 0.6, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0.6 }}
        transition={{ duration: 0.4, delay: 1 }}
      >
        <OfficeTitle text={text} text2={text2} />
        <AboutMe />
        <Footer />
      </motion.main>
    </>
  );
};

export default AboutMePage;
